import { css } from 'styled-components';
export const transitionCssMixin = (...transitionProperties) => css `
	transition: ${transitionProperties.map(prop => `${prop} 0.12s ease-in-out`).join(', ')};
`;
export const visuallyHidden = css `
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
	height: 1px;
	overflow: hidden;
	position: absolute;
	white-space: nowrap;
	width: 1px;
`;
export const disableEvents = `
	pointer-events: none;
	cursor: default;
`;
export const disableInput = `
	${disableEvents}
	opacity: 0.56;
`;
